<template >
    <div class="basic-layout">
        <Menu/>
        <slot/>
    </div>
    <Cart />
</template>

<script>
import Menu from '../components/Menu.vue';
import Cart from '../components/Cart/Cart.vue';
export default {
    name:'BasicLayouts',
    components:{
        Menu,
        Cart
    }
}
</script>

<style scoped>

</style>